import { Clickable, Col, Icon, MediaModal, Row, Text } from 'components';
import { imageResizer } from 'core';
import { theme } from 'lib';
import { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RemoveButton } from 'screens/Admin/components';
import styled from 'styled-components';

const Preview = styled.div`
  position: relative;
  border: 1px solid #ddd;
  border-radius: 7px;
  background-image: ${(props) => `url(${props.img})`};
  width: 120px;
  height: 120px;
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const Media = ({ media, setMedia, error, isEditing, isProcessing }) => {
  const [previews, setPreviews] = useState([]),
    fileInput = useRef(),
    dispatch = useDispatch();

  async function handleFile(e) {
    const files = Array.from(e?.target?.files);
    fileInput.current.value = '';
    if (!files.length) return;

    let mapped = Array.from(media);

    for await (let file of files) {
      if ((mapped?.length || 0) >= 10) break;

      const uri = await imageResizer({
        height: 1080,
        width: 1080,
        format: 'png',
        file,
        output: 'blob',
        quality: 70
      });

      const thumbnail = await imageResizer({
        height: 300,
        width: 300,
        format: 'png',
        file,
        output: 'blob',
        quality: 100
      });

      mapped.push({ uri, thumbnail, preview: URL.createObjectURL(uri) });
    }

    setMedia(mapped);
  }

  function removeFile(idx) {
    setMedia(media.filter((x, i) => i !== idx));
  }

  return (
    <Col noFlex>
      <Text marg="24px 16px 5px" b2 med>
        Images
      </Text>

      <Col>
        <input
          multiple
          type="file"
          ref={fileInput}
          accept="image/*"
          style={{ width: 0, height: 0, opacity: 0 }}
          onChange={(event) => handleFile(event)}
        />

        {!!media?.length && (
          <Row gap="21px" start wrapFlex>
            {media?.map((x, i) => (
              <Col pos="relative" noFlex key={i}>
                <RemoveButton onClick={() => removeFile(i)} />

                <MediaModal media={x.preview || x.uri}>
                  <Preview img={x.preview || x.uri}></Preview>
                </MediaModal>
              </Col>
            ))}

            {!!((media?.length || 0) < 10) && (
              <Col noFlex center>
                <Clickable onClick={() => fileInput.current.click()}>
                  <Row center marg="0 0 0 32px">
                    <Icon type="add" dimensions={12} marg="0 6px 0 0" />

                    <Text>Add</Text>
                  </Row>
                </Clickable>
              </Col>
            )}
          </Row>
        )}

        {!media?.length && (
          <Col marg="7px 0 0">
            <Clickable onClick={() => fileInput.current.click()}>
              <Row center>
                <Icon type="camera" dimensions="24" />

                <Text b2 marg="0 0 0 8px">
                  Add images
                </Text>
              </Row>
            </Clickable>
          </Col>
        )}

        {error && (
          <Row noFlex>
            <Text c1 bold marg="4px 0 0 16px" col={theme.SECONDARY}>
              {error}
            </Text>
          </Row>
        )}
      </Col>
    </Col>
  );
};

export default Media;
